import Vue from 'vue';
import { ngVueEventBus, EVENT_CAMPAIGNS_UPDATED, EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED } from '@/angularBridgeCode/utilities/ngVueEventBus';

import { setActionStatusError, setActionStatusSuccess, setActionStatusPending, resetActionStatus } from '@/store/helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  resetActionStatus,

  setCampaignSettings(state, { campaignId, val }) {
    if (!state.campaigns[campaignId] || !state.campaigns[campaignId].publishers) {
      Vue.set(state.campaigns, campaignId, val);
    } else {
      const publishers = state.campaigns[campaignId].publishers;
      Vue.set(state.campaigns, campaignId, { publishers, ...val });
    }

    ngVueEventBus.$emit(EVENT_CAMPAIGNS_UPDATED);
  },

  setPublisherSettings(state, { campaignId, affiliateId, val }) {
    if (!state.campaigns[campaignId].publishers) {
      Vue.set(state.campaigns[campaignId], 'publishers', {});
    }
    Vue.set(state.campaigns[campaignId].publishers, affiliateId, val);

    ngVueEventBus.$emit(EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED, { affiliateId });
  },

  setAllPublisherSettings(state, { campaignId, publishers }) {
    Vue.set(state.campaigns[campaignId], 'publishers', publishers);
  },

  setSetupVal(state, { campaignId, val }) {
    let temp = state.campaigns;

    if (temp[campaignId]) {
      temp[campaignId].setupVal = val;
      temp[campaignId].enabled = val;
    } else {
      temp = {
        ...temp,
        [campaignId]: {
          setupVal: val,
          enabled: val
        }
      };
    }

    state.campaigns = { ...temp };
  },

  setBulkModifiers(state, bulkModifiers) {
    state.bulkModifiers = [...bulkModifiers];
  },

  setCampaignSettingsOverride(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'campaignSettingsOverride', val);
    
    ngVueEventBus.$emit(EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED, { affiliateId });
  },

  setCampaignSettingsOverrideWithoutNotification(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'campaignSettingsOverride', val);
  },

  setEnabled(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'enabled', val);
  },

  setPayoutCapacity(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'capps', val);
  },

  setSipOnly(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'sipOnly', val);
  },

  setCallerIdRequired(state, { campaignId, affiliateId, val }) {
    if (affiliateId) {
      _setProperty(state, campaignId, affiliateId, 'callerIdRequiredOverride', val);
    } else {
      _setProperty(state, campaignId, affiliateId, 'callerIdRequired', val);
    }
  },

  setMacros(state, macros) {
    Vue.set(state, 'macros', macros);
  },

  setIcp(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'icp', val);
  },

  setJournayaTcpa(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'journayaTcpa', val);
    _setProperty(state, campaignId, affiliateId, 'journayaTcpaModified', true);
  },

  setTrustedForm(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'trustedForm', val);
    _setProperty(state, campaignId, affiliateId, 'trustedFormModified', true);
  },

  setTrustedFormIntegration(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'trustedFormIntegration', { integrationMethod: val });
  },

  setTrustedFormSettings(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'trustedFormSettings', val);
  },

  setJornayaSettings(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'jornayaSettings', val);
  },

  setBidExpirationInSeconds(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'bidExpirationInSeconds', val);
  },

  setRouteCallsForStaleBids(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'routeCallsForStaleBids', val);
  },

  setRateLimitOverride(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'rateLimitOverride', val);
  },

  setMaxRequests(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'maxRequests', val);
  },

  setPerSeconds(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'perSeconds', val);
  },

  setBidSettingsOverride(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'bidSettingsOverride', val);
  },

  setBaseBidAmount(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'baseBidAmount', val);
  },

  setmaxBidAmount(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'maxBidAmount', val);
  },

  setminBidAmount(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'minBidAmount', val);
  },

  setConversionType(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'conversionType', val);
  },

  setStartTimerEvent(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'startTimerEvent', val);
  },

  setCallLengthInSeconds(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'callLengthInSeconds', val);
  },

  setSecondsFromLastCall(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'secondsFromLastCall', val);
  },

  setPassThroughBid(state, { campaignId, affiliateId, val }) {
    if (affiliateId) {
      _setProperty(state, campaignId, affiliateId, 'maxBid', val.maxBid);
      _setProperty(state, campaignId, affiliateId, 'bidMarginPercentage', val.bidMarginPercentage);
      _setProperty(state, campaignId, affiliateId, 'bidMarginAmount', val.bidMarginAmount);
      _setProperty(state, campaignId, affiliateId, 'minBidMarginPercentageAfterAdjustments', val.minBidMarginPercentageAfterAdjustments);
      _setProperty(state, campaignId, affiliateId, 'minBidMarginAmountAfterAdjustments', val.minBidMarginAmountAfterAdjustments);
      _setProperty(state, campaignId, affiliateId, 'allowBidsAtLoss', val.allowBidsAtLoss);
    } else {
      _setProperty(state, campaignId, affiliateId, 'passThroughBid', val);
    }
  },
  setPassThroughBidOverride(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'passThroughBidOverride', val);
  },

  setCustomScoringSettings(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'customScoring', val);
    _setProperty(state, campaignId, affiliateId, 'customScoringModified', true);
  },

  setCustomScoringModified(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'customScoringModified', val);
  },

  setBidAdjustmentsOverride(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'bidAdjustmentsOverride', val);
  },

  saveBidAdjustments(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'bidAdjustments', val?.map(({id, ...ba}) => ba));
  },

  setMinDurationAdjustments(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'minDurationAdjustments', val);
  },
  setMinDurationAdjustmentsOverride(state, { campaignId, affiliateId, val }) {
    _setProperty(state, campaignId, affiliateId, 'minDurationAdjustmentsOverride', val);
  },

  setRows(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'rows', val);
  },

  setRowsPreviousState(state, {campaignId, affiliateId, val}) {
    _setProperty(state, campaignId, affiliateId, 'rowsPreviousState', val);
  },
};

const _setProperty = (state, campaignId, affiliateId, property, val) => {
  if (!campaignId) {
    return;
  } else if (affiliateId) {
    if (!state.campaigns[campaignId].publishers) {
      Vue.set(state.campaigns[campaignId], 'publishers', {});
    }
    if (!state.campaigns[campaignId].publishers[affiliateId]) {
      Vue.set(state.campaigns[campaignId].publishers, affiliateId, {});
    }
    const temp = state.campaigns[campaignId].publishers[affiliateId];
    temp[property] = val;
    state.campaigns[campaignId].publishers[affiliateId] = { ...temp };
  } else {
    const temp = state.campaigns[campaignId];
    temp[property] = val;
    state.campaigns[campaignId] = { ...temp };
  }
};